import { MIVConstants } from "@1oo4/miv";

export class DocIDS {
    static readonly ID_ROOT_DATA: number = 2;
    static readonly TYPE_ROOT_DATA: number = 2;

    static readonly TY_CHAPTER: number = 200;
    static readonly TY_ARTICLE: number = 220;
    static readonly TY_SECTION: number = 240;
    static readonly TY_TEXT: number = 250;
    static readonly TY_PICTURE: number = 260;
    static readonly TY_CODE: number = 270;
    static readonly TY_CODE_TAB: number = 272;
    static readonly TY_TABLE: number = 280;
    static readonly TY_TABLE_COLUMN: number = 282;
    static readonly TY_TABLE_CELL: number = 284;
    static readonly TY_TABLE_CELL_TEXT: number = 288;
    static readonly TY_TABLE_CELL_PICTURE: number = 290;

    static readonly PR_TEXT: number = 2048;
    static readonly PR_DATA: number = 2050;

    static readonly PR_CODE: number = 2100;
    static readonly PR_CODE_LANGUAGE: number = 2102;
    static readonly PR_CODE_CS: number = 2104;
    static readonly PR_CODE_TS: number = 2106;
    static readonly PR_CODE_HTML: number = 2108;
    static readonly PR_CODE_XAML: number = 21010;
    static readonly PR_CODE_SQL: number = 21012;
    static readonly PR_CODE_JSON: number = 2114;
    static readonly PR_CODE_PSEUDO: number = 2121;

    static readonly PR_WIDTH: number = 2222;
}